(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDropdown);
  } else {
    initDropdown();
  }

  function initDropdown() {
    const menuTriggers = document.querySelectorAll(".header-menu-trigger");
    const dropdown = document.querySelector(".header-menu-dropdown");
    const overlay = document.querySelector(".header-menu-overlay");

    if (!dropdown || !overlay) return;

    const dropdownLinks = dropdown.querySelector(".dropdown-links");
    const dropdownPreview = dropdown.querySelector(".dropdown-preview");
    let currentActiveMenu = null;

    menuTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const menuHandle = this.getAttribute("data-menu-handle");

        if (
          currentActiveMenu === menuHandle &&
          dropdown.classList.contains("header-menu-dropdown--active")
        ) {
          closeDropdown();
        } else {
          populateDropdown(menuHandle);
          openDropdown(menuHandle);
        }
      });
    });

    function openDropdown(menuHandle) {
      dropdown.classList.add("header-menu-dropdown--active");
      overlay.classList.add("is-active");
      currentActiveMenu = menuHandle;
    }

    function closeDropdown() {
      dropdown.classList.remove("header-menu-dropdown--active");
      overlay.classList.remove("is-active");
      currentActiveMenu = null;
    }

    async function populateDropdown(menuHandle) {
      const menuDataElement = document.querySelector(
        `script.header-menu-data[data-menu-handle="${menuHandle}"]`
      );

      if (!menuDataElement) return;

      let menuData;
      try {
        menuData = JSON.parse(menuDataElement.textContent);
      } catch {
        return;
      }

      dropdownLinks.innerHTML = "";
      dropdownPreview.innerHTML = "<p>Loading products...</p>";

      menuData.forEach((item, index) => {
        const li = document.createElement("li");
        const a = document.createElement("a");

        a.href = item.url;
        a.textContent = item.title;
        a.className = "dropdown-link";
        a.dataset.collectionHandle = item.handle;

        a.addEventListener("click", function (e) {
          e.preventDefault();

          dropdownLinks
            .querySelectorAll(".dropdown-link")
            .forEach((l) => l.classList.remove("active"));

          this.classList.add("active");

          if (item.type === "collection") {
            loadCollectionProducts(item.handle, item.title);
          } else {
            loadPagePreview(item.url, item.title);
          }
        });

        li.appendChild(a);
        dropdownLinks.appendChild(li);

        if (index === 0) {
          a.classList.add("active");

          if (item.type === "collection") {
            loadCollectionProducts(item.handle, item.title);
          } else {
            loadPagePreview(item.url, item.title);
          }
        }
      });
    }

    async function loadCollectionProducts(collectionHandle, collectionTitle) {
      dropdownPreview.innerHTML = "<p>Loading products...</p>";

      try {
        const res = await fetch(
          `/collections/${collectionHandle}?section_id=mega-menu-product-card`
        );

        const html = await res.text();
        const dom = new DOMParser().parseFromString(html, "text/html");
        const cards = dom.querySelector(".shopify-section");

        if (!cards || !cards.innerHTML.trim()) {
          dropdownPreview.innerHTML = `<p>No products found in ${collectionTitle}</p>`;
          return;
        }

        dropdownPreview.innerHTML = `
            <h3 class="dropdown-title">${collectionTitle}</h3>
            <div class="dropdown-product-grid">
              ${cards.innerHTML}
            </div>
            <a href="/collections/${collectionHandle}" class="view-all-link">
              View all products →
            </a>
          `;
      } catch {
        dropdownPreview.innerHTML = "<p>Error loading products</p>";
      }
    }

    async function loadPagePreview(url, title) {
      dropdownPreview.innerHTML = "<p>Loading content...</p>";

      try {
        const res = await fetch(url);
        const html = await res.text();
        const dom = new DOMParser().parseFromString(html, "text/html");

        const container =
          dom.querySelector(".rte") ||
          dom.querySelector(".page-width") ||
          dom.querySelector("main");

        if (!container) {
          dropdownPreview.innerHTML = "<p>No preview available</p>";
          return;
        }

        const blocks = Array.from(
          container.querySelectorAll("p, h2, h3, ul")
        ).slice(0, 4);

        const previewHtml = blocks.map((el) => el.outerHTML).join("");

        dropdownPreview.innerHTML = `
            <h3 class="dropdown-title">${title}</h3>
            <div class="dropdown-page-preview">
                ${previewHtml}
            </div>
            <a href="${url}" class="view-all-link content">
                Read more →
            </a>
            `;
      } catch {
        dropdownPreview.innerHTML = "<p>Error loading page</p>";
      }
    }

    overlay.addEventListener("click", closeDropdown);

    document.addEventListener("click", function (e) {
      if (
        !e.target.closest(".header__inline-menu") &&
        !e.target.closest(".header-menu-dropdown")
      ) {
        closeDropdown();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDropdown();
    });
  }
})();
